import { GridValueFormatterParams } from '@mui/x-data-grid-pro'
import { store } from '@user/store/store'
import { selectSalesTeamById } from '@user/store/salesTeam/slice'

export const salesTeamValueFormatter = ({ value }: GridValueFormatterParams) =>
  typeof value === 'number'
    ? selectSalesTeamById(store.getState(), value)?.name ?? ''
    : ''
